import {
  VERIFY_EMAIL,
  VERIFY_EMAIL_SUCCESSFUL,
  VERIFY_EMAIL_FAILED,
  RESET_PASSWORD, RESET_PASSWORD_FAILED, RESET_PASSWORD_SUCCESSFUL
} from "./actionTypes"

export const verifyEmail = (user, callback) => {
  return {
    type: VERIFY_EMAIL,
    payload: { user, callback },
  }
}

export const verifyEmailSuccessful = user => {
  return {
    type: VERIFY_EMAIL_SUCCESSFUL,
    payload: user,
  }
}

export const verifyEmailFailed = user => {
  return {
    type: VERIFY_EMAIL_FAILED,
    payload: user,
  }
}

export const resetPassword = (user, callback) => {
  return {
    type: RESET_PASSWORD,
    payload: { user, callback },
  }
}

export const resetPasswordSuccessful = user => {
  return {
    type: RESET_PASSWORD_SUCCESSFUL,
    payload: user,
  }
}

export const resetPasswordFailed = user => {
  return {
    type: RESET_PASSWORD_FAILED,
    payload: user,
  }
}